import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Breadcrumbs, type BreadcrumbItem } from '@/components/ui';

/** Breadcrumbs wired to the router (the design system is router-agnostic). */
export function RouterBreadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <Breadcrumbs
      items={items}
      renderLink={(item, children: ReactNode) => <Link to={item.href}>{children}</Link>}
    />
  );
}
